/* src/app/components/tool-section/tool-section.component.scss */
.section {
  margin-top: 3.75rem;
}
.section .ic-info {
  font-size: 1.5625rem;
  line-height: 1.5625rem;
  font-weight: 300;
  color: rgba(116, 116, 128, 0.32);
  margin-left: 0.5rem;
}
.section .title {
  font-size: 1.125rem;
  line-height: 1.5rem;
  color: #72727f;
  margin-bottom: 0;
}
.section .title-info {
  display: flex;
  align-items: center;
  padding-bottom: 0.5rem;
  border-bottom: 0.0625rem solid rgba(46, 46, 56, 0.08);
  margin-bottom: 1.5rem;
}
.section .title-info .big-title {
  font-size: 2rem;
  line-height: 2.5rem;
  font-weight: 300;
  color: #2e2e38;
}
.section .description {
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 300;
  color: #72727f;
  margin-bottom: 0;
}
.section .no-border {
  border: 0;
}
/*# sourceMappingURL=tool-section.component.css.map */
